<!-- store-index -->

<template>
  <div ref="wrapper" class="index-page-3">

    <div class="bg"></div>

    <div class="content-box">
      <city-select :cate-id="goodsCateId"
        :search-background-color="'linear-gradient(90deg, #1966C5, #0053C4)'"></city-select>

      <ads-images :imageRadius="0" code="index_images"></ads-images>

      <div class="box4 mt10">
        <div class="flex-row row-between flex-wrap">
          <div v-for="(item, index) of cateList" :key="index" class="item-box">
            <router-link :to="item.cateId
              ? `/cate-index?cateId=${item.cateId}`
              : `/goods-cate-list`
              " style="color: #333">
              <div class="flex-col col-center">
                <div :style="{ background: item.color }" class="flex-row col-center row-center" style="
                    width: 40px;
                    height: 40px;
                    border-radius: 50%;
                    color: white;
                  ">
                  <span :class="[item.icon]" class="iconfont" style="font-size: 20px"></span>
                </div>
                <div class="mt14" style="text-align: center">
                  {{ item.name }}
                </div>
              </div>
            </router-link>
          </div>
        </div>
      </div>

      <div class="box5 mt10 flex-row col-center">
        <span class="iconfont icon-rexiaochanpin" style="font-size: 20px; color: #ff2404"></span>
        <div class="ml8" @click="opeNotice">{{ sysNoticeTitle }}</div>
      </div>

      <div class="box6 mt10">
        <img v-if="storeIndexTopAd" :src="storeIndexTopAd" alt="" style="height: 100px" v-on:click="
          $router.replace({ path: 'topic-detail', query: { topicId: 9 } })" />
      </div>

      <div class="box7">
        <div class="box7-1">
          <div class="flex-row">
            <div class="flex-row col-center" style="
                height: 38px;
                background: linear-gradient(90deg, #ff2404, #ff9b60);
                padding: 0 10px;
                color: white;
                line-height: 38px;
                font-size: 14px;
                font-weight: bold;
              ">
              <span>限时兑换</span>
              <van-count-down :time="time" class="ml8">
                <template #default="timeData">
                  <span class="block">{{ timeData.hours }}</span>
                  <span class="colon">:</span>
                  <span class="block">{{ timeData.minutes }}</span>
                  <span class="colon">:</span>
                  <span class="block">{{ timeData.seconds }}</span>
                </template>
              </van-count-down>
            </div>
            <div class="flex-row col-center row-around" style="height: 38px; font-size: 14px;margin-left: 8px;">
              <div :class="[timeStatus === 1 ? 'item-box-active' : '']" class="item-box"
                v-on:click="changeTimeStatus(1)">
                今日热卖
              </div>
              <div :class="[timeStatus === 2 ? 'item-box-active' : '']" class="item-box"
                v-on:click="changeTimeStatus(2)">
                明日预告
              </div>
            </div>
          </div>
          <div style="max-height: 552px; overflow-y: auto">
            <div style="padding: 6px">
              <goods-unit v-for="item in goodsListByTime" :key="item.goodsId" :goods-id="item.goodsId" :goods-style="4"
                :head-image="item.headImage" :name="item.name" :original-price="item.originalPrice" :price="item.price"
                :spec="item.spec" class="goods-item-box mt6 flex-row"></goods-unit>
            </div>
          </div>
        </div>
        <div class="box7-2 mt10">
          <div style="background-color: #d0e2ff;padding: 8px;border-radius: 5px">
            <div style="font-size: 15px; color: #252525; font-weight: bold;">
              热销推荐
            </div>
            <div style="margin-top: 10px;width: 100%; white-space: nowrap; overflow-x: auto">
              <goods-unit v-for="(item, index) in goodsListByHot" :key="item.goodsId" :goods-id="item.goodsId"
                :goods-style="3" :head-image="item.headImage" :name="item.name" :price="item.price"
                :saleCount="item.saleCount" :spec="item.spec" :style="{ 'margin-left': index === 0 ? '' : '12px' }"
                style="
                  font-size: 12px;
                  color: #333333;
                  display: inline-block;
                  width: 29vw;
                "></goods-unit>
            </div>
          </div>

          <topic-list-index class="mt12"></topic-list-index>
        </div>
      </div>

      <div class="box8 mt10 store-index-index-110">
        <van-tabs v-model="tabActive" background="rgba(0,0,0,0)">
          <van-tab title="精选">
            <MallSortTable :cate-id="goodsCateId" :exclude-cate-ids="listExcludeCateIds" :tag="tag" />
          </van-tab>
          <van-tab v-for="cate in allCateList" :key="cate.cateId" :title="cate.name">
            <MallSortTable :cate-id="cate.cateId" />
          </van-tab>
        </van-tabs>
      </div>
    </div>

    <PageFooter :active="0"></PageFooter>

    <van-popup v-model="showAdsImage" style="background:none">
      <div style="text-align: center">
        <van-image :src="adsImageSrc" width="300" @click="$router.push(adsImageTargetUrl)" />
        <van-icon color="#f5f5f5" name="close" size="42" style="margin-top: 32px" @click="showAdsImage = false" />
      </div>
    </van-popup>
  </div>
</template>

<script>
import { api_get_goods_cate_list, api_get_goods_list_by_params, wx_get_goods_list_by_topic } from "@/api/goods-api";
import Vue from "vue";
import { Dialog, Lazyload } from "vant";
import GoodsUnit from "@/components/common/goods-unit";
import CitySelect from "@/components/common/city-select";
import AdsImages from "@/components/common/ads-images";
import MallSortTable from "@/components/common/MallSortTable";
import { GOODS_CATE_INFO, GOODS_TAGS } from "@/api/constant";
import TopicListIndex from "@/components/common/topic-list-index";
import { getSysConfigValue } from "@/api/sys-api";
import PageFooter from "@/components/common/page-footer";

Vue.use(Lazyload);

export default {
  name: "index",
  components: { PageFooter, TopicListIndex, AdsImages, GoodsUnit, CitySelect, MallSortTable },
  data() {
    return {
      goodsListByHot: [], //热销商品
      goodsListByTime: [], //限时热卖
      timeStatus: 1, //限时热卖类型 1=今天 2=明天
      time: 24 * 60 * 60 * 1000 - Date.now(),
      cateList: [],
      allCateList: [],
      goodsList: [],
      tabActive: 0,

      //商城商品类别编号
      goodsCateId: GOODS_CATE_INFO.general.id,
      tag: GOODS_TAGS.sale,
      listExcludeCateIds: GOODS_CATE_INFO.books.id,

      sysNoticeTitle: '',
      showAdsImage: false,
      adsImageSrc: '',
      adsImageTargetUrl: '',
      storeIndexTopAd: '',
      timerId: -1
    };
  },

  mounted() {
    window.onscroll = this.doScroll;
    const d = new Date();
    this.time = 24 * 60 * 60 * 1000 - (d.getHours() * 60 * 60 * 1000 + d.getMinutes() * 60 * 1000 + d.getSeconds() * 1000);
  },

  created() {
    //加载类别
    const cateColor = [
      "linear-gradient(-36deg, #FC3F3F, #FD6359)",
      "linear-gradient(-36deg, #FF9634, #FFBA4D)",
      "linear-gradient(-36deg, #3FB8FE, #51CFFC)",
      "linear-gradient(-36deg, #25C8B5, #5AD7BA)",
      "linear-gradient(-36deg, #B82EDB, #C958F8)",
      "linear-gradient(-36deg, #25C8B5, #5AD7BA)",
      "linear-gradient(-36deg, #FC3F3F, #FD6359)",
      "linear-gradient(-36deg, #576BFF, #7095FD)",
      "linear-gradient(-36deg, #FF4001, #FF7622)",
    ];

    api_get_goods_cate_list(GOODS_CATE_INFO.general.id).then((res) => {
      this.allCateList = res.data;

      //remove books class
      this.allCateList = this.allCateList.filter(
        (c) => c.cateId !== GOODS_CATE_INFO.books.id
      );

      this.cateList = res.data.slice(0, 9).map((item, index) => {
        return {
          name: item.name,
          cateId: item.cateId,
          icon: item.icon,
          color: cateColor[index],
        };
      });

      this.cateList.push({
        name: "更多",
        icon: "icon-gengduo",
        color: "linear-gradient(-36deg, #3FB8FE, #51CFFC)",
      });
    });

    //top
    getSysConfigValue('store_index_top_ad').then(res => {
      this.storeIndexTopAd = res.data;
    })

    //hot
    api_get_goods_list_by_params({ tag: "热销", cateId: 1 }).then((res) => {
      this.goodsListByHot = res.data.records;
    });

    this.changeTimeStatus(1);

    getSysConfigValue('Page_Notice_Title').then(res => {
      this.sysNoticeTitle = res.data;
    })

    if (!sessionStorage.getItem('store_index_ads_show_flag')) {
      getSysConfigValue('Index_Ads_Image').then(res => {
        this.adsImageSrc = res.data;
        if (res.data && res.data.length > 0) {
          sessionStorage.setItem("store_index_ads_show_flag", 1);
          this.showAdsImage = true;
        }
      })

      getSysConfigValue('Index_Ads_Target').then(res => {
        this.adsImageTargetUrl = res.data;
      })
    }
  },

  methods: {
    doScroll() {
      if (this.timerId) clearTimeout(this.timerId);
      this.timerId = setTimeout(() => {
        // 获取页面滚动距离之后设置给当前路由的元信息
        this.$route.meta.y = window.pageYOffset;
        budo_log.debug('#318 store-index doScroll', window.pageYOffset)
      }, 300);
    },

    forbidBack() {
      window.history.pushState('forward', null, '#');
      window.history.forward(1);
    },

    changeTimeStatus(e) {
      this.timeStatus = e;
      //7=今日热卖,8=明日预膏
      wx_get_goods_list_by_topic(e === 1 ? 7 : 8, "", 1, 4).then((res) => {
        this.goodsListByTime = res.data.records;
      });
    },

    opeNotice() {
      getSysConfigValue('Page_Notice').then(res => {
        Dialog.alert({ title: this.sysNoticeTitle, message: res.data });
      })
    }
  }
};
</script>

<style lang="scss" scoped>
@import "index";
</style>
